import { createClient } from "@sanity/client";
import { apiVersion, projectId, dataset as defaultDataset } from "./api";
import { createImageUrlBuilder } from "@sanity/image-url/signed";

let _dataset = defaultDataset;

export const setSanityDataset = (dataset: string) => {
	_dataset = dataset;
};

export const getClient = () =>
	createClient({
		projectId,
		dataset: _dataset,
		apiVersion,
		useCdn: true,
	});
const builder = createImageUrlBuilder(getClient());
export const urlFor = (source: string) => builder.image(source);
export const webpUrlFor = (source: string) => builder.image(source).format(`webp`).url();
export const jpgUrlFor = (source: string) => builder.image(source).format(`jpg`).url();
